import axios from 'axios';
import { EnterpriseData, Decision } from '../entity/entity.types';
import { EnterprisePopoverInfos } from './components/popover/enterprisePopover.types';
import { EnterpriseDecisions } from './enterprise.types';

export async function fetchEnterpriseDecisions(
  siren: string,
): Promise<EnterpriseDecisions> {
  return (
    await axios.get('/getEnterpriseDecisions', {
      params: {
        siren,
      },
    })
  ).data;
}

export function fetchEnterpriseCaseCount(
  siren: string,
): Promise<{ data: CaseDataType }> {
  return axios.get('/getEnterpriseCaseCount', {
    params: {
      siren,
    },
  });
}

export type CaseDataType = {
  caseData: {
    years: number[];
    caseCounts: number[];
  };
};

export function fetchEnterpriseCaseCountForSearchSnippet(
  siren: string,
): Promise<{ data: CaseDataType }> {
  return axios.get('/getEnterpriseCaseCountForSearchSnippet', {
    params: {
      siren,
    },
  });
}

export function fetchEntrepriseLawFirms(siren: string, full: boolean = false) {
  return axios.get('/getEnterpriseLawFirms', {
    params: {
      siren,
      full,
    },
  });
}

export function fetchEntrepriseLawyers(siren: string, full: boolean = false) {
  return axios.get('/getEnterpriseLawyers', {
    params: {
      siren,
      full,
    },
  });
}

export function fetchEntrepriseOpponents(siren: string, full: boolean = false) {
  return axios.get('/getOppositeEnterprises', {
    params: {
      siren,
      full,
    },
  });
}

export function fetchEntrepriseKeywords(siren: string) {
  return axios.get('/getEnterpriseKeywords', {
    params: {
      siren,
    },
  });
}

export function fetchOppositeEnterprisesCaseCount(
  siren: string,
): Promise<{
  data: {
    oppositeEnterprisesCaseCount: Array<EnterpriseData>;
  };
}> {
  return axios.get('/getOppositeEnterprisesCaseEvolution', {
    params: {
      siren,
    },
  });
}

export function fetchEnterpriseInfos(
  siren: string,
): Promise<{ data: EnterprisePopoverInfos }> {
  return axios.get('/getEnterprisePopover', {
    params: {
      siren,
    },
  });
}

export async function fetchEnterpriseTopDecisions(
  siren: string,
): Promise<Decision[]> {
  return (
    await axios.get('/getEnterpriseTopDecisions', {
      params: {
        siren,
      },
    })
  ).data.arrets;
}
